import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { NumberText } from "share-components/atomics/number-text";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const ProductInventoryTable = observer(() => {
  const {
    productInventoryManagement: {
      productInventoryStore: {
        productsInventory,
        getProductsInventory,
        pagination,
      },
    },
  } = useStores();

  useEffect(() => {
    getProductsInventory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getProductsInventory();
    },
    [getProductsInventory, pagination]
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Tên giao dịch</TableCell>
          <TableCell>Mã hàng</TableCell>
          <TableCell>Tên hàng</TableCell>
          <TableCell>Mã vạch</TableCell>
          <TableCell>ĐVT</TableCell>
          <TableCell>SL tồn</TableCell>
          <TableCell>Tổng nhập</TableCell>
          <TableCell>Tổng xuất</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {productsInventory.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.customer?.dealingName || ""}</TableCell>
            <TableCell>{x.code}</TableCell>
            <TableCell>{x.name}</TableCell>
            <TableCell>{x.barcode}</TableCell>
            <TableCell>{x.unitOfCalculation}</TableCell>
            <TableCell>
              <NumberText value={x.totalQuantity}></NumberText>
            </TableCell>
            <TableCell>
              <NumberText value={x.importQuantity}></NumberText>
            </TableCell>
            <TableCell>
              <NumberText value={x.exportQuantity}></NumberText>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
